/**
 *
 * @param color income color
 * @param defaultColor when not income color use default color
 * @param useMain is use primary.main to set color when not have value
 */
function parseColor(color, defaultColor, useMain) {
    if (useMain === void 0) { useMain = true; }
    // * when there is not color pass into and have defaultColor, just using default color
    if (!color && defaultColor !== undefined) {
        return defaultColor;
    }
    var result = ['primary', 'main'];
    if (color) {
        if (color instanceof Array) {
            result = color;
        }
        else if (typeof color === 'string') {
            var colors = color.split('.');
            result = colors;
        }
        else {
            // if that is theme send back
            return color;
        }
    }
    if (useMain) {
        if (!result[0]) {
            result[0] = 'primary';
        }
        if (!result[1]) {
            result[1] = 'main';
        }
    }
    return result;
}
export { parseColor };
